import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal';
import { CANCEL_TEXT, DELETE_STAFFING_DIALOG } from '../../../../Constants/strings';
import alertIcon from '../../../../Assets/images/svg/alert_icon.svg';

const DeleteConfirm = ({ selectedRequest, onCancel, onConfirm, isDeleting }) => {
  const content = DELETE_STAFFING_DIALOG;
  const handleConfirm = () => onConfirm(selectedRequest);
  const displayId = selectedRequest?.sr_number || selectedRequest?.srNumber || selectedRequest?.request_id;
  return (
    <FormDialog
      open={Boolean(selectedRequest)}
      title={content.TITLE_TEXT}
      dialogBodycontent={(
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">
            <div>
              Delete staffing request {displayId}?
            </div>
            <div>This action cannot be undone.</div>
          </div>
        </div>
      )}
      PaperProps={{}}
      button2Action={handleConfirm}
      dialogCss="dialog-message"
      dialogPaperCss="sr-delete-dialog-paper"
      width={200}
      height={205}
      button1Action={onCancel}
      button1={CANCEL_TEXT}
      cancelButtonId={`cancel-${content.BUTTON_ID}`}
      button2={content.BUTTON_TEXT}
      submitButtonId={content.BUTTON_ID}
      disableSubmit={isDeleting}
    />
  );
};

DeleteConfirm.propTypes = {
  selectedRequest: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
};

DeleteConfirm.defaultProps = {
  selectedRequest: null,
  isDeleting: false,
};

export default DeleteConfirm;
